import React from "react"
import cn from "classnames"
import USD from "../../components/usd"
import { calculateCart } from "../../shop/common"
import FieldReservation from "./cart/field-reservation"
import CartItem from "./cart/item"
import Discount from "./cart/discount"

class Cart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {showQuantityControl: false}
    this.setQuantityControl = () => this.setState({showQuantityControl: true})
  }

  decreaseItem(item, index) {
    this.props.onDecreaseItem({id: item.productId, index: index})
  }

  increaseItem(item) {
    if (!item.isPinned) {
      this.props.onIncreaseItem(item.productId)
    }
  }

  setDiscount(index, discount) {
    this.props.onSetDiscount(index, discount)
  }

  correctDiscount(index) {
    this.props.onCorrectDiscount(index)
  }

  showCartItems(cart) {
    return cart.items.map((item, index) => {
      return (
        <CartItem 
          key={index} products={this.props.products} item={item} index={index}
          showDiscountPerItem={this.props.showDiscountPerItem}
          setQuantityControl={this.setQuantityControl} showQuantityControl={this.state.showQuantityControl} 
          decreaseItem={this.decreaseItem.bind(this)} increaseItem={this.increaseItem.bind(this)}
          onSetDiscount={(discount) => {this.setDiscount(index, discount)}}
          onCorrectDiscount={(discount) => {this.correctDiscount(index, discount)}}
        />
      )
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.cart.items.length === 0 && !nextProps.cart.reservationId) {
      this.setState({showQuantityControl: false})
    }
  }

  render() {
    const title = this.props.title || "Sale";
    const {discount, reservationId} = this.props.cart
    const amount = discount.type == "amount" ? discount.amount : 0.0
    const percentage = discount.type == "percentage" ? discount.amount : 0
    const {taxAndFeeAmount, totalAmount, appFee} = calculateCart(this.props.cart, this.props.products);
    const isButtonDisabled = (!this.props.cart.reservationId && this.props.cart.items.length === 0) ||
      !this.props.onClickButton
    const cartHasItems = this.props.cart.items.length > 0 || reservationId
    return (
      <div className="shop-cart">
        <div className="shop-cart__title">{title}</div>
        {cartHasItems &&
          <table className={
            cn(
                "shop-cart__items",
                { "shop-cart__items--small" : reservationId }
              )
            }>
            <tbody>
              <FieldReservation cart={this.props.cart}
                onClick={this.setQuantityControl}
                onClickMinus={this.state.showQuantityControl ? this.props.onRemoveReservation : undefined} />
              {this.showCartItems(this.props.cart)}
            </tbody>
          </table>
        }
        {this.props.cart.items.length > 1 &&
          <Discount
            amountDiscount={amount}
            percentageDiscount={percentage}
            onSetDiscount={(discount) => {this.setDiscount(-1, discount)}}
            onCorrectDiscount={() => {this.correctDiscount(-1)}}
          />
        }
        <table className="shop-cart__items shop-cart__tax">
          <tbody>
            <tr className="shop-cart__option"><td>Tax & Fees</td><td><USD val={taxAndFeeAmount}/></td></tr>
          </tbody>
        </table>
        {this.props.buttonText &&
          <button disabled={isButtonDisabled}
            className="btn btn-success shop-cart__submit"
            onClick={() => this.props.onClickButton()}>
            {this.props.buttonText} <USD val={totalAmount - appFee}/>
          </button>
        }
      </div>
    )
  }
}

export default Cart
